import React, { Component } from 'react';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { history, GenerateCSV, store } from '../../_helpers';
import { Loader } from '../../_components';

import { CSVLink } from "react-csv";

import Card from './_components/Cards.block';
import UsersDataChart from './_components/Users.block';
import OriginPageview from './_components/Origin.block';
import DevicesPageview from './_components/Devices.block';
import OptinChart from './_components/Optin.block';
import MomentumsChart from './_components/MomentumsChart.block';
import EventsChart from './_components/Events.block';

import { DatePicker, Space } from 'antd';
import dayjs from 'dayjs';



import './Dashboard.scss';

class DashboardContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      analytics: [],
      domains: [],
      domain: '',
      dateValue: '',
      updating: false,
      loaded: false,
      selected: false,
      sidebarIsReady: true,
      generatingCsv: false,
      period: 1,
      start: dayjs(),
      end: dayjs()
    }

    this.CSVLink = React.createRef();

    this.changePeriod = this.changePeriod.bind(this);
    this.handleDataToCSV = this.handleDataToCSV.bind(this);
  }

  async componentDidMount() {
    document.title = "Dashboard - Cellit.io";

    if (!store.getState().changeDomainReducer.selectedDomain) return history.push('/domains');

    this.setState({ domain: store.getState().changeDomainReducer.selectedDomain.domain_uuid })

    if (this.props.domainsLoaded) {
      return history.push(`?domain=${JSON.parse(sessionStorage.getItem('selected_domain')).uuid}`);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.generatingCsv) return false;
    return true;
  }

  componentWillReceiveProps(nextProps) {
    if (!store.getState().changeDomainReducer.selectedDomain) return;

    this.setState({
      domain: store.getState().changeDomainReducer.selectedDomain.domain_uuid,
      updating: true
    }, () => {
      this.setState({ updating: false })
    })
  }

  changePeriod(e) {
    let start = dayjs();
    let end = dayjs();

    if (e && e.length > 0) {
      start = dayjs(e[0]);
      end = dayjs(e[1]);
    }

    this.setState({ start, end })
  }

  async handleDataToCSV(e) {
    let btn = e.target;
    let valuesForCSV = [];

    let cardPeriod = `Entre os dias ${this.state.start.format("DD/MM/YYYY")} - ${this.state.end.format("DD/MM/YYYY")}.`

    let headers = { value: cardPeriod };

    let values = document.querySelectorAll('input[name="datatocsv"]');
    await [...values].map(input => {
      valuesForCSV.push({ "value": input.value });
    });

    let now = new Date();
    this.setState({ analytics: [], generatingCsv: true }, () => {
      this.setState({ analytics: valuesForCSV }, () => {
        GenerateCSV(headers, this.state.analytics, `cell_dashboard_export_${now.toISOString().split('T')[0]}`);
        this.state.generatingCsv = false
      });
    })
  }
  
  render() {
    const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY'];
    const dateFormat = 'DD/MM/YYYY';
    const { RangePicker } = DatePicker;
    return (
      
      <>
        {
          this.state.sidebarIsReady ?
            <section className="component component-dashboard">
              <div className="component-header">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col">
                      <h1 className="title">Dashboard</h1>
                    </div>
                    <div className="col">
                      <div className="mx-auto input-group input-group-has-btn">
                        <label htmlFor="none">Extrair para:</label>
                        <button className="btn btn-small btn-white" onClick={this.handleDataToCSV}>CSV</button>
                      </div>
                    </div>
                    <div className="col">
                      <div className="input-group">
                        {/* <label htmlFor="period">Período:</label>
                        <select name="period" id="period" className="form-control" onChange={this.changePeriod}>
                          <option value="1">Últimas 24 horas</option>
                          <option value="7">Últimos 7 dias</option>
                          <option value="30">Últimos 30 dias</option>
                          <option value="60">Últimos 60 dias</option>
                          <option value="90">Todo o período</option>
                        </select> */}
                        <Space direction="vertical" size={12}>
                          <RangePicker
                            defaultValue={[this.state.start, this.state.end]}
                            disabled={[false, false]}
                            format={dateFormat}
                            onChange={this.changePeriod}
                          />
                        </Space>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="component-body">
                {
                  !this.state.updating && this.state.domain.length !== 0 ?
                    <div className="container-fluid">
                      <div className="data-group">
                        <div className="row">
                          <Card key={`/count/visits`} title="Visualizações de Página" icon="linearicons-eye" endpoint={`/count/visits`} period={{ start: this.state.start, end: this.state.end }} />
                          <Card key={`/count/momentums`} title="Momentums inativos" icon="linearicons-flag3" endpoint={`/count/momentums`} period={{ start: this.state.start, end: this.state.end }} />
                        </div>
                      </div>

                      {/* First row of data */}
                      <div className="data-group">
                        <div className="row">
                          <UsersDataChart key={`/count/persons/category`} type="channels" title="Visitantes por categoria" endpoint={`/count/persons/category`} period={{ start: this.state.start, end: this.state.end }} colsize="4" parentDomain={this.state.domain} />
                          <UsersDataChart key={`/count/persons/devices`} type="channels" title="Visitantes por dispositivo" endpoint={`/count/persons/devices`} period={{ start: this.state.start, end: this.state.end }} colsize="4" parentDomain={this.state.domain} />
                          <UsersDataChart key={`/count/persons/channel`} type="channels" title="Base por Canal" endpoint={`/count/persons/channel`} period={{ start: this.state.start, end: this.state.end }} colsize="4" parentDomain={this.state.domain} />

                          <MomentumsChart key={`/count/peopleImpacted`} type="momentums" title="Impacto por Momentum" endpoint={`/count/dailyPeopleImpacted`} period={{ start: this.state.start, end: this.state.end }} colsize="8" className="inverted" parentDomain={this.state.domain} />
                          <EventsChart key={`/count/eventDailyPeopleImpacted`} type="events" title="Impacto por evento" period={{ start: this.state.start, end: this.state.end }} endpoint={`/count/eventDailyPeopleImpacted`} colsize="4" parentDomain={this.state.domain} />

                          <OptinChart key={`/count/persons/daily-optin-optout`} type="optin" title="Optins e optouts diários" endpoint={`/count/persons/daily-optin-optout`} period={{ start: this.state.start, end: this.state.end }} colsize="12" parentDomain={this.state.domain} />
                        </div>
                      </div>
                    </div>
                    : <Loader />
                }
              </div>
            </section>
            : null
        }
      </>
    )
  }
}

const mapStateToProps = (state) => {
  const { dashboard } = state.listDashboardData;
  return dashboard;
}

const ConnectedDashboardContainer = connect(mapStateToProps)(DashboardContainer);
export { ConnectedDashboardContainer as DashboardContainer }